<template>
  <div class="d-flex flex-column" :style="`gap: ${gapInPx}`">
    <template v-if="!!content">
      <form-node v-for="(item, i) in content" :key="contentKeys[i]" v-bind="item" v-on="$listeners" />
    </template>
    <slot v-else />
  </div>
</template>

<script>
import { PropsDefinition, Computed } from '@/_typedefs'
import { FormNodeProps } from '../FormNode.vue'

/**
 * @typedef {Object} ColumnNodeProps
 * @property {number} gap
 * @property {FormNodeProps[]} content
 */

export default {
  name: 'ColumnNode',
  /** @type {PropsDefinition<ColumnNodeProps>} */
  props: {
    gap: {
      type: Number,
      default: 6,
    },
    content: {
      type: Array,
      default: null,
    },
  },
  computed: {
    /** @type {Computed<string>} */
    gapInPx() {
      return `${this.gap * 4}px`
    },
    /** @type {Computed<string[]>} */
    contentKeys() {
      return Array(this.content.length)
        .fill()
        .map((_) => Math.random().toString(36).substring(2, 8))
    },
  },
}
</script>

<style></style>
